import { useTranslation } from 'react-i18next';
import './PublicPage.css';

export default function CookiePolicyPage() {
    const { t } = useTranslation();
    
    return (
        <div className="public-page cookie-policy-page">
            <header className="public-hero">
                <div className="public-hero-content">
                    <h1>{t('cookie_policy.hero_title')}</h1>
                    <p>{t('cookie_policy.hero_subtitle')}</p>
                </div>
            </header>

            <div className="legal-content-wrapper legal-text">
                {/* Introduction */}
                <h2>{t('cookie_policy.s1_title')}</h2>
                <p>{t('cookie_policy.s1_text')}</p>

                {/* What are cookies */}
                <h2>{t('cookie_policy.s2_title')}</h2>
                <p>{t('cookie_policy.s2_text')}</p>

                {/* Categories of cookies */}
                <h2>{t('cookie_policy.s3_title')}</h2>
                <p>{t('cookie_policy.s3_intro')}</p>

                {/* Necessary cookies */}
                <h3>{t('cookie_policy.s3_necessary_title')}</h3>
                <p>{t('cookie_policy.s3_necessary_text')}</p>
                <div className="cookie-table">
                    <table>
                        <thead>
                            <tr>
                                <th>{t('cookie_policy.table_name')}</th>
                                <th>{t('cookie_policy.table_provider')}</th>
                                <th>{t('cookie_policy.table_purpose')}</th>
                                <th>{t('cookie_policy.table_duration')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>raisa_session</td>
                                <td>Raisa.chat</td>
                                <td>{t('cookie_policy.cookie_session')}</td>
                                <td>{t('cookie_policy.duration_session')}</td>
                            </tr>
                            <tr>
                                <td>raisa_cookie_consent</td>
                                <td>Raisa.chat</td>
                                <td>{t('cookie_policy.cookie_consent')}</td>
                                <td>{t('cookie_policy.duration_1year')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Analytics cookies */}
                <h3>{t('cookie_policy.s3_analytics_title')}</h3>
                <p>{t('cookie_policy.s3_analytics_text')}</p>
                <div className="cookie-table">
                    <table>
                        <thead>
                            <tr>
                                <th>{t('cookie_policy.table_name')}</th>
                                <th>{t('cookie_policy.table_provider')}</th>
                                <th>{t('cookie_policy.table_purpose')}</th>
                                <th>{t('cookie_policy.table_duration')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>plausible_ignore</td>
                                <td>Plausible Analytics</td>
                                <td>{t('cookie_policy.cookie_plausible')}</td>
                                <td>{t('cookie_policy.duration_forever')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Marketing / Third-party cookies */}
                <h3>{t('cookie_policy.s3_marketing_title')}</h3>
                <p>{t('cookie_policy.s3_marketing_text')}</p>
                <div className="cookie-table">
                    <table>
                        <thead>
                            <tr>
                                <th>{t('cookie_policy.table_name')}</th>
                                <th>{t('cookie_policy.table_provider')}</th>
                                <th>{t('cookie_policy.table_purpose')}</th>
                                <th>{t('cookie_policy.table_duration')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>_gyg_*</td>
                                <td>GetYourGuide</td>
                                <td>{t('cookie_policy.cookie_gyg')}</td>
                                <td>{t('cookie_policy.duration_2years')}</td>
                            </tr>
                            <tr>
                                <td>__stripe_*</td>
                                <td>Stripe</td>
                                <td>{t('cookie_policy.cookie_stripe')}</td>
                                <td>{t('cookie_policy.duration_session')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Functionality cookies */}
                <h3>{t('cookie_policy.s3_functionality_title')}</h3>
                <p>{t('cookie_policy.s3_functionality_text')}</p>
                <div className="cookie-table">
                    <table>
                        <thead>
                            <tr>
                                <th>{t('cookie_policy.table_name')}</th>
                                <th>{t('cookie_policy.table_provider')}</th>
                                <th>{t('cookie_policy.table_purpose')}</th>
                                <th>{t('cookie_policy.table_duration')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>i18nextLng</td>
                                <td>Raisa.chat</td>
                                <td>{t('cookie_policy.cookie_language')}</td>
                                <td>{t('cookie_policy.duration_1year')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Google Consent Mode */}
                <h2>{t('cookie_policy.s4_title')}</h2>
                <p>{t('cookie_policy.s4_text')}</p>

                {/* Managing cookies */}
                <h2>{t('cookie_policy.s5_title')}</h2>
                <p>{t('cookie_policy.s5_text')}</p>

                {/* Third-party links */}
                <h2>{t('cookie_policy.s6_title')}</h2>
                <p>{t('cookie_policy.s6_text')}</p>
                <ul className="legal-list">
                    <li><a href="https://www.getyourguide.com/privacy_policy" target="_blank" rel="noopener noreferrer">GetYourGuide Privacy Policy</a></li>
                    <li><a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">Stripe Privacy Policy</a></li>
                    <li><a href="https://plausible.io/data-policy" target="_blank" rel="noopener noreferrer">Plausible Data Policy</a></li>
                </ul>

                {/* Updates */}
                <h2>{t('cookie_policy.s7_title')}</h2>
                <p>{t('cookie_policy.s7_text')}</p>

                {/* Contact */}
                <h2>{t('cookie_policy.s8_title')}</h2>
                <p>{t('cookie_policy.s8_text')}</p>
            </div>
        </div>
    );
}
